const SPACE_DATA = {

};
export const SPACE_MAP = {

}